var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRetailerChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3577 7.33887C15.2382 7.35419 15.1157 7.36339 14.987 7.36339C14.1889 7.36339 13.4793 7.01472 12.9897 6.47578C12.5053 7.0141 11.7944 7.36339 10.9948 7.36339C10.1966 7.36339 9.48551 7.01472 8.99836 6.47578C8.50998 7.0141 7.80222 7.36339 6.99948 7.36339C6.20104 7.36339 5.49022 7.01472 5.00306 6.47578C4.51775 7.0141 3.80693 7.36339 3.00603 7.36339C2.88173 7.36339 2.75632 7.35466 2.63469 7.33874C0.939753 7.11215 0.137753 5.1145 1.04423 3.68061L2.80044 0.902287C2.95686 0.652581 3.23582 0.5 3.53363 0.5H14.4655C14.7632 0.5 15.0422 0.65252 15.1987 0.902287L16.9549 3.68061C17.864 5.11757 17.0582 7.11215 15.3577 7.33887Z",
    fill: "#E34B31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.8633 7.20439L15.8664 14.717C15.8664 15.5292 15.2079 16.1877 14.4233 16.1877H3.6078C2.79557 16.1877 2.16472 15.5292 2.16472 14.717L2.13806 7.20439C2.29564 7.26478 2.4564 7.31485 2.63472 7.33884C2.75635 7.35452 2.88166 7.36371 3.00606 7.36371C3.39639 7.36371 3.76345 7.27832 4.09526 7.13104V12.2659H13.9024V7.13086C14.2333 7.27793 14.601 7.36371 14.987 7.36371C15.1139 7.36371 15.2356 7.35534 15.3575 7.33942C15.5416 7.31469 15.704 7.26567 15.8633 7.20439Z",
    fill: "#E34B31"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetailerChecked);
export default __webpack_public_path__ + "static/media/retailer-checked.1eee6d2fddb870279086244843f86dc6.svg";
export { ForwardRef as ReactComponent };